import object from 'helpers/object'
import moment from 'moment'


export const initialState = {
  schedule: [],
  isFetching: true,
}


export const resetSchedule = (state) => (
  object.setIn(state, [ 'schedule' ], [])
)

// // the same reducer already exists - 'updateExistedSchedule'
// export const updateSchedule = (state, { data, year, month }) => {
//   const filteredSchedule = state.schedule.filter(({ day }) => {
//     const yearMonth = moment(day, 'DD.MM.YYYY').format('MM.YYYY')
//     const payloadYearMonth = `${month}.${year}`

//     return yearMonth !== payloadYearMonth
//   })

//   return (
//     object.setIn(state, [ 'schedule' ], filteredSchedule.concat(data))
//   )
// }

export const updateExistedSchedule = (state, payload) => (
  object.setIn(state, [ 'schedule' ],
    state.schedule.filter(({ day }) => (
      moment(day, 'DD.MM.YYYY').format('MM.YYYY') !== `${payload.month}.${payload.year}`
    ))
      .concat(payload.data)
  )
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
